module.exports = __webpack_public_path__ + "202408221624/img/home_case_2.cc6e0fa5.jpg";